import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import {
    Contact,
    Session,
    ContactService,
    RegistrationDetailService,
    SessionService,
    TrainingSessionCompany,
    TrainingSessionContact,
} from '../../../../../../_services';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
    selector: 'registration-contact',
    templateUrl: 'registration-contact.component.html',
    styleUrls: [
        './registration-contact.component.scss',
        '../../registration.component.scss',
        '../../../../../_shared/label/label.component.scss',
    ],
})
export class RegistrationContactComponent implements OnInit {
    @Input() tsContact: TrainingSessionContact;
    @Input() tsContacts: TrainingSessionContact[];
    @Input() tsCompany: TrainingSessionCompany;
    @Input() tsCompanies: TrainingSessionCompany[];
    @Input() session: Session;
    @Input() newRegistration: any;
    @Output() create: EventEmitter<TrainingSessionContact> = new EventEmitter();

    contacts: Contact[];
    showCreateStudentPanel: boolean = false;
    private deleteModalRef;

    constructor(
        private contactService: ContactService,
        private modalService: NgbModal,
        private sessionService: SessionService,
        private registrationDetailsService: RegistrationDetailService
    ) {}

    ngOnInit(): void {
        if (!this.tsContact) {
            this.tsContact = {
                firstName: '',
                lastName: '',
                selected: false,
                students: [],
                editingMode: 'addOrEdit',
                emailingMode: 'CONTACT_AND_STUDENTS',
            };
        }

        this.getAllContactsByCompanyId(this.tsCompany.companyId);
        if (
            this.tsContact.students.length === 0 &&
            this.tsContact.editingMode !== 'addOrEdit'
        ) {
            this.showCreateStudentPanel = true;
        }
    }

    getAllContactsByCompanyId(id) {
        this.contactService
            .findContactsByCompanyId(id)
            .subscribe((contacts) => {
                this.contacts = contacts;
            });
    }

    toggleRegistrationContact(): void {
        this.updateStudentState();
    }

    updateStudentState() {
        const students = [].concat.apply([], this.tsContact.students);
        students.forEach(
            (student) => (student.selected = !this.tsContact.selected)
        );
        this.registrationDetailsService.updateRegistrationSelection(
            this.tsCompanies
        );
    }

    editContact() {
        this.tsContact.editingMode = 'addOrEdit';
    }

    confirmChanges(contact: TrainingSessionContact) {
        contact.editingMode = 'noEdition';
        contact.selected = false;

        if (contact.students.length > 0) {
            contact.students.forEach((student) => {
                student.contactId = contact.id;
                student.companyId = this.tsCompany.companyId;
                this.sessionService
                    .updateStudentToCompanySession(student, this.session.id)
                    .subscribe();
            });
        }

        if (this.tsContact.students.length === 0) {
            this.addStudent();
        }

        this.create.emit(contact);
    }

    getNewContact(event: TrainingSessionContact) {
        event.editingMode = 'addOrEdit';
        this.tsContact = event;
    }

    addStudent() {
        this.showCreateStudentPanel = true;
    }

    tsStudentCreated(createdtsStudent) {
        this.showCreateStudentPanel = false;
        if (createdtsStudent != null) {
            this.tsContact.students.push(createdtsStudent);
            setTimeout((_) => this.addStudent(), 3);
        }
    }

    cancel(contact: TrainingSessionContact) {
        contact.editingMode = 'noEdition';
        if (!this.tsContact.id) {
            this.tsCompany.contacts = this.tsCompany.contacts.filter(
                (contact) => contact !== this.tsContact
            );
        }
        this.create.emit(null);
    }

    removeContact(
        contact: TrainingSessionContact,
        company: TrainingSessionCompany
    ): void {
        company.contacts = company.contacts.filter((c) => c.id !== contact.id);

        this.tsContact.students.forEach((student) => {
            this.registrationDetailsService
                .delete(student.registrationDetailId)
                .subscribe();
        });

        this.deleteModalRef.close();
    }

    changeContactEmailingMode(
        contact: TrainingSessionContact,
        emailingMode: string
    ): void {
        this.contactService
            .changeEmailingMode(contact.id, emailingMode)
            .subscribe((_) => (contact.emailingMode = emailingMode));
    }

    closeDeleteModal() {
        this.deleteModalRef.close();
    }

    openDeleteModal(deleteModal) {
        event.stopPropagation();
        this.deleteModalRef = this.modalService.open(deleteModal);
    }

    isDisabled(tsContact: TrainingSessionContact) {
        if (tsContact.firstName === '' || tsContact.email === '') {
            return true;
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/_screens/session/detail/registration/registration-company/registration-contact/registration-contact.component.ts